import TemplatingTextInput from './TemplatingTextInput';

export default TemplatingTextInput;
